<template>
  <div class="course-container">
    <!-- 左侧导航栏（窄版） -->
    <div class="left-nav">
      <div class="nav-item" @click="goToComponent('Video')">视频</div>
      <div class="nav-item" @click="goToComponent('Recording')">录音</div>
      <div class="nav-item" @click="goToComponent('Screenshot')">截图</div>
      <div class="nav-item" @click="goToComponent('Document')">文档</div>
    </div>
    <!-- 内容区域 -->
    <div class="content-area">
      <div class="course-list">
        <div
          v-for="(course, index) in courseList"
          :key="index"
          class="course-item"
          @click="goToCourseDetail(course.id)"
        >
          <img
            v-if="course.cover_url"
            :src="course.cover_url"
            class="course-cover"
            alt="课程封面"
          />
          <div class="course-info">
            <div class="course-name">{{ course.title }}</div>
          </div>
        </div>
        <!-- 无数据提示 -->
        <div v-if="courseList.length === 0" class="empty-tip">暂无视频内容</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import http from '@/util/request';
import { useRouter } from 'vue-router';

// 状态
const courseList = ref([]);
const router = useRouter();

// 获取视频列表（当前组件只显示视频）
const fetchVideos = () => {
  const params = {
    page: 1,
    page_size: 10,
    type: '视频' // 只获取视频类型内容
  };
  http.get('/api/ok/courses/', { params })
    .then(res => {
      courseList.value = res.data.results; // 直接使用接口返回的真实数据
    })
    .catch(err => {
      ElMessage.error('获取视频列表失败');
      console.error(err);
    });
};

// 跳转到对应组件页面
const goToComponent = (componentName) => {
  if (componentName === 'Video') {
    router.push({ name: 'ShiPin' }); // 视频组件路由名
  } else if (componentName === 'Recording') {
    router.push({ name: 'ShiPin' }); // 录音组件路由名
  } else if (componentName === 'Screenshot') {
    router.push({ name: 'ShiPin' }); // 截图组件路由名
  } else if (componentName === 'Document') {
    router.push({ name: 'ShiPin' }); // 文档组件路由名
  }
};

// 跳转到视频详情页并传递ID
const goToCourseDetail = (id) => {
  // 确保 id 存在再跳转（避免传递 undefined）
  if (id) {
    router.push({
      path: '/mobile/interview',
      query: { courseId: id } // 传递课程 ID 到 query
    });
  } else {
    ElMessage.warning('课程信息有误');
  }
};

// 页面加载时获取视频列表
onMounted(() => {
  fetchVideos();
});
</script>

<style scoped>
.course-container {
  display: flex;
  min-height: calc(100vh - 60px);
  background-color: #fff;
}

.left-nav {
  width: 80px;
  background-color: #f5f5f5;
  padding: 15px 0;
}

.nav-item {
  padding: 15px 8px;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nav-item:hover {
  background-color: #eee;
}

.content-area {
  flex: 1;
  padding: 20px;
  background-color: #fff;
  overflow-y: auto;
}

.course-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.course-item {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 10px;
  transition: box-shadow 0.2s ease-in-out;
  width: 100%;
  box-sizing: border-box;
  justify-content: flex-start;
}

.course-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.course-cover {
  width: 140px;
  height: 80px;
    object-fit: cover;
  border-radius: 4px;
  margin-right: 15px;
    flex-shrink: 0;
}

.course-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.course-name {
  font-weight: 500;
  font-size: 15px;
  color: #333;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.empty-tip {
  text-align: center;
  padding: 30px 0;
  color: #999;
  font-size: 14px;
}
</style>